export default __webpack_public_path__ + "images/AdobeStock.jpg";